// extracted by mini-css-extract-plugin
export default {"budgetEventsCarousel":"BudgetEventsCarousel-module__budgetEventsCarousel___1wEq6"};